import cloneDeep from 'clone-deep'
import { useEffect, useState } from 'react'
import { Modal } from 'stories/components'
import { InputValidate } from 'utils'
import { RenderInput } from 'utils/RenderInput'

import { defaultInputs } from './constants'
import { IExpirationDateConfigItem } from './type'

export const AddExpirationDateTypeModal = ({
  data,
  defaultLoanType,
  isTemplate,
  onClose,
}: {
  data: IExpirationDateConfigItem | null
  defaultLoanType?: number
  isTemplate?: boolean
  onClose: Function
}) => {
  const [isLoading, setLoading] = useState(false)
  const [inputs, setInputs] = useState(defaultInputs())

  useEffect(() => {
    const newInputs = cloneDeep(inputs)
    if (isTemplate) {
      newInputs.loanType.visible = true
      newInputs.visibleLogic.visible = true
    } else {
      newInputs.loanType.visible = false
    }
    if (!data) {
      if (defaultLoanType !== undefined) newInputs.loanType.value = { [`${defaultLoanType}`]: true }
      setInputs(newInputs)
      return
    }
    newInputs.loanType.visible = false
    newInputs.title.value = data.title
    newInputs.days.value = data.days
    newInputs.isOnlyExpiredDate.value = data.type ? true : false
    newInputs.isSeasoning.value = data.seasonType ? true : false
    // newInputs.isCoBorrower.value = data[4] ? true : false
    newInputs.days.disabled = newInputs.isOnlyExpiredDate.value
    newInputs.calculateBasedOn.value = data.calculateBasedOn
    newInputs.isRequired.value = data.isRequired === undefined ? true : data.isRequired === 1 ? true : false
    newInputs.visibleLogic.value = data.visibleLogic || []
    setInputs(newInputs)
  }, [])

  const onChange = (key: string, value: any) => {
    const newInputs = cloneDeep(inputs)
    newInputs[key].value = value
    newInputs[key].error = ''
    if (key == 'isOnlyExpiredDate') newInputs.days.disabled = newInputs.isOnlyExpiredDate.value
    setInputs(newInputs)
  }

  const onSubmit = async () => {
    const newInputs = cloneDeep(inputs)
    let values: Record<string, any> = {}
    let hasError = false
    Object.keys(inputs).forEach((key) => {
      if (inputs[key].visible === false) return null
      newInputs[key].error = InputValidate(newInputs[key])
      const { value, error } = newInputs[key]
      if (error) hasError = true
      values[key] = value
    })
    setInputs(newInputs)
    if (hasError) return false

    setLoading(true)
    await onClose({
      title: values.title,
      days: Number(values.days),
      type: values.isOnlyExpiredDate,
      seasonType: values.isSeasoning,
      calculateBasedOn: Number(values.calculateBasedOn) || 1,
      isRequired: values.isRequired === false ? 0 : 1,
      visibleLogic: values.visibleLogic,
      loanType: values.loanType,
      // isCoBorrower: values.isCoBorrower,
    })
    setLoading(false)
  }

  return (
    <Modal
      isOpen
      loading={isLoading}
      title={`${data ? 'Update' : 'Add'} Expiration Date`}
      titleOkay="Submit"
      onClose={() => onClose(null)}
      onOk={onSubmit}
    >
      <div className="w-128">
        {Object.keys(inputs).map((key) => {
          const input = inputs[key]
          if (input.visible === false) return null

          return (
            <div className="mb-4" key={key}>
              <RenderInput Key={key} input={input} onChange={onChange} />
            </div>
          )
        })}
      </div>
    </Modal>
  )
}
